export const tldrawLicenseKey = location.hostname.endsWith('.com')
  ? import.meta.env.VITE_TLDRAW_LICENSE_KEY_COM
  : import.meta.env.VITE_TLDRAW_LICENSE_KEY_RU;
